import { render, staticRenderFns } from "./Dahua.vue?vue&type=template&id=6ca890c0&scoped=true"
import script from "./Dahua.vue?vue&type=script&lang=js"
export * from "./Dahua.vue?vue&type=script&lang=js"
import style0 from "./Dahua.vue?vue&type=style&index=0&id=6ca890c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca890c0",
  null
  
)

export default component.exports